import type { FaireProductEntity } from "../../entity_types/product";

export const p_ja7uc2dnz4: FaireProductEntity = {
  token: "p_ja7uc2dnz4",
  type: "product",
  name: "I Don't Get Enough Credit Hat",
  brandToken: "b_tacvsj4rz9",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/afa107ed2a5ce4e21d1ccc197df7ba27be2786e15b2a9ddd05a94dd3a6c47cfe.png",
  galleryImageUrls: [],
  priceDollars: 24.94,
  description:
    "This hat from 9 Priscilla Way is a unique addition to your accessories. This unisex trucker hat comes with a striking embroidered detail that adds a touch of personality to any outfit. 9 Priscilla Way has crafted this hat with care and creativity. Wear it knowing that each piece from our brand carries a story of personal expression.",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:53.329Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
